var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDiamonYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 67,
    viewBox: "0 0 78 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_6189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.66 21.2532L39 65.0828L77.5 21.2532H54.66Z",
    fill: "#FFE182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.431 1.91699L0.5 21.2536H23.34L16.431 1.91699Z",
    fill: "#FFCD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66 21.2536H77.5L61.569 1.91699L54.66 21.2536Z",
    fill: "#FFCD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66 21.2536L39 1.91699L23.34 21.2536H54.66Z",
    fill: "#FFCD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 1.91699H16.4312L23.3401 21.2536L39.0001 1.91699Z",
    fill: "#FFAA64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.569 1.91699H39L54.66 21.2536L61.569 1.91699Z",
    fill: "#FFE182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 21.2532L39 65.0828L54.66 21.2532H23.34Z",
    fill: "#FFAA64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.2532L39 65.0828L23.34 21.2532H0.5Z",
    fill: "#FF8C5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_6189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 67,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamonYellow);
export default __webpack_public_path__ + "static/media/icDiamonYellow.531e0bdd573b3ee68ef25ef80e581c84.svg";
export { ForwardRef as ReactComponent };